import { DomainService } from './../../services/domain.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Observable, Subject, BehaviorSubject } from 'rxjs/';

import { LicenseService } from '../../services/license.service';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { ProfileService } from '../profile/profile.service';

import { ReactiveFormComponent } from '../../../shared/components/reactive-form/reactive-form.component';
import {ItpxValidators} from '../../../shared/validators/itpx-validators';

declare var moment: any;

@Component({
    selector: 'itpx-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css']
})
export class RegisterComponent extends ReactiveFormComponent {

    private languageConfig: any;
    private timezoneConfig: any;
    private domain: any;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private profileService: ProfileService,
        private licenseService: LicenseService,
        private authService: AuthService,
        private notificationService: NotificationService,
        private domainService: DomainService
    ) {
        super();
    }

    ngOnInit() {

        this.domain = this.domainService.getDomain();

        this.form = this.fb.group({
            key: [null],
            username: [null, [Validators.required]],
            firstName: [null, [Validators.required, Validators.minLength(2), ItpxValidators.nonAsciiCharacter]],
            lastName: [null, [Validators.required, Validators.minLength(2), ItpxValidators.nonAsciiCharacter]],
            language: ['eng', [Validators.required]],
            timeZone: [moment.tz.guess(), [Validators.required]],
            password: [null, [Validators.required, Validators.minLength(6)]],
            confirmPassword: [null, [Validators.required, Validators.minLength(6)]],
            consent: [false, [Validators.required, ItpxValidators.booleanValidator]]
        });

        this.languageConfig = {
            label: 'Language',
            hideForm: true,
            placeholder: 'Select language...',
            initialItem: { key: 'eng' },
            forceRefresh: Observable.never(),
            required: true,
            questions: [],
            dictionaryFactory: () => this.profileService.getLanguagesDictionary().map(body => body.data)
        };

        this.timezoneConfig = {
            label: 'Timezone',
            hideForm: true,
            initialItem: { key: moment.tz.guess() },
            required: true,
            placeholder: 'Select timezone...',
            forceRefresh: Observable.never(),
            questions: [],
            dictionaryFactory: () => this.profileService.getTimezonesDictionary().map(body => body.data)
        };

        super.ngOnInit();

        this.route.params
            .map(params => params['key'])
            .take(1)
            .flatMap(secret => this.licenseService.validateRegistration(secret)
                .map(res => res.data)
                .map(learner => ({ learner: learner, secret: secret }))
            )
            .bindToLifecycle(this)
            .subscribe(data => {
                this.form.patchValue({
                    key: data.secret,
                    username: data.learner.username,
                    firstName: data.learner.firstName,
                    lastName: data.learner.lastName
                }, {emitEvent: false});

                this.form.controls.username.disable();

                this.ready();
            }, err => {
                this.error();
            });

        Observable.combineLatest(this.form.controls.password.valueChanges, this.form.controls.confirmPassword.valueChanges,
            (password, confirm) => ({ password: password, confirm: confirm }))
            .filter(data => data.password && data.confirm)
            .bindToLifecycle(this)
            .subscribe(data => {
                if (data.password.localeCompare(data.confirm) != 0) {
                    this.form.controls.confirmPassword.setErrors({ msg: 'Passwords do not match.' });
                }
            });

        let formData = this.formSubmit.take(1).shareReplay();

        this.submitSuccess
            .withLatestFrom(formData, (_, formData) => formData)
            .do(_ => this.submitting.next(true))
            .flatMap(data => this.authService.basicAuth(data)
                .doOnEach(() => this.submitting.next(false))
                .neverError()
            )
            .bindToLifecycle(this)
            .subscribe(res => {
                this.notificationService.success(res.username, 'Welcome,')
                this.router.navigate(['app']);
            });
    }

    protected getFormSubmitQuery(data: any): Observable<any> {
        return this.licenseService.completeRegistration(this.form.controls.key.value, data)
            .map(body => body.data);
    }

    private isValidEmail(value: string) {
        // TODO: Extract to service
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
    }

    private onRegister({ value, valid }: { value: any, valid: boolean }) {
        this.formSubmit.next(this.form.getRawValue());
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/register/register.component.ts